import {Pipe, PipeTransform} from '@angular/core';
import { Period, Customer } from 'src/app/generated/sales-terminal-client';
import { CustomTicket } from 'src/app/modules/sales-terminal/cart/table/cart-table.component';

@Pipe({
  name: 'addSpaces',
  pure: false
})
export class AddSpacesPipe implements PipeTransform {
  constructor() {
  }

  transform(value: string | number | Period | CustomTicket | Customer,
            groupBy: number = 3,
            maxDigitsWithoutTransforming: number = 4) {
    if (typeof value !== 'string') {
      value = value.toString();
    }
    const parts = value.split('.');
    if (parts[0].length > maxDigitsWithoutTransforming) {
      parts[0] = parts[0].replace(new RegExp('\\B(?=(\\d{' + groupBy + '})+(?!\\d))', 'g'), ' ');
    }
    return parts.join(".") + ' ';
  }
}
